const translation = {
  // Nav
  nav_home: "Home",
  nav_about: "About Us",
  nav_services: "Services",
  nav_contact: "Contact",
  nav_estimation: "Estimation",
  nav_looking_for: "What We're Looking For",

  // Hero
  hero_title: "Continental Antiques",
  hero_subtitle: "Visit Us and Discover Unique Antique Finds",
  hero_cta: "SELL YOUR ITEMS",

  // About
  about_title: "About Us",
  about_section1_title: "About Continental Antiques",
  about_section2_title: "Our Story",
  about_section3_title: "Our Mission",
  about_p1: `Continental Antiques is a family business built on a shared passion that has been passed down from father to son. Antiques have been part of our lives for generations, shaping not only our work but also our appreciation for history, craftsmanship, and timeless design.
We grew up surrounded by antiques in our father's small shop, learning the trade from an early age. What began as a childhood experience gradually became a lifelong passion. Over the years, while pursuing various projects and responsibilities, we always kept the shop alive and remained deeply connected to the world of antiques.`,
  about_p2: "Our journey began with a deep appreciation for the stories that each antique tells. Every piece in our collection has been carefully selected for its historical significance, artistic merit, and timeless beauty. From elegant furniture to exquisite decorative objects, we bring you treasures that connect the past with the present.",
  about_p3: "At Continental Antiques, we believe that antiques are more than just objects, they are windows into different eras, cultures, and craftsmanship traditions. Our expertise allows us to guide collectors, decorators, and enthusiasts in finding pieces that resonate with their personal style and vision.",
  about_heritage_title: "Our Heritage",
  about_heritage_p1: "With decades of experience in the antique trade, our family has built a reputation for authenticity, quality, and exceptional service. We have came across various pieces from all around the world while establishing relationships with trusted sources and developing an eye for truly remarkable pieces.",
  about_heritage_p2: "Our knowledge spans multiple periods and styles, from Renaissance and Baroque to Art Nouveau and Art Deco. This breadth of expertise ensures that we can assist clients with diverse tastes and collecting interests.",
  about_mission_title: "Our Mission",
  about_mission_p1: `Each piece we offer is selected with care, guided by the knowledge and appreciation passed down through our family. We value authenticity, craftsmanship, and the stories that antiques carry through time.
From decorative objects to distinctive vintage finds, our goal is simple: to connect people with beautiful pieces of history that can be appreciated and enjoyed for generations to come.`,
  about_mission_p2: "Whether you're a seasoned collector or just beginning your journey into the world of antiques, we invite you to explore our collection and discover the perfect piece that speaks to you.",

  // Services
  services_title: "Our Services",
  services_subtitle: "We offer comprehensive services to meet all your antique needs, from acquisition to restoration",
  service1_title: "Buying & Selling",
  service1_desc: "We purchase quality antiques and offer a curated selection of authenticated pieces for sale. Our inventory is constantly updated with new acquisitions from Canada and around the world.",
  service2_title: "Appraisal & Authentication",
  service2_desc: "Our expert team provides professional appraisals and authentication services. We help you understand the value, provenance, and historical significance of your antiques.",
  service3_title: "Watch Servicing & Jewelry Repair",
  service3_desc: "We work with skilled craftsmen to restore / repair / service watches and repair jewelry.",
  service4_title: "Buy & Sell Gold & Silver",
  service4_desc: "We offer trusted services for buying and selling gold and silver, including jewelry, coins, bullion, and silverware. Our experts provide fair market evaluations and competitive prices based on current gold and silver rates.",
  service5_title: "Movie Film, Event & Prop Rentals",
  service5_desc: "We specialize in antique prop rentals for movies, film productions, events, and photo shoots. Our curated selection of vintage furniture, decorative antiques, and unique props adds timeless style and authenticity to any set or event.",
  service6_title: "Rug Cleaning",
  service6_desc: "We specialize in area rug cleaning, wall-to-wall carpet cleaning, and commercial carpet cleaning services. Our expert cleaning removes deep dirt, allergens, and stains, leaving your rugs and carpets clean, fresh, and well maintained.",

  // Contact
  contact_title: "Contact Us",
  contact_subtitle: "Visit our showroom or get in touch to discuss your antique needs",
  contact_address_title: "Address",
  contact_address_label: "Address",
  contact_phone_label: "Phone",
  contact_email_label: "Email",
  contact_hours_label: "Opening Hours",
  contact_hours_1: "Tuesday - Saturday: 11:00 AM - 5:00 PM",
  contact_hours_2: "Monday: By Appointment Only",
  contact_follow: "Follow Us",
  contact_get_directions: "Get Directions",

  // Estimation
  estimation_title: "Estimation / Sell Your Items",
  estimation_subtitle: "Have antiques to sell? We offer free appraisals and competitive prices for quality pieces",
  estimation_how_title: "How It Works",
  estimation_step1_title: "Contact Us",
  estimation_step1_desc: "Reach out via phone, email, or visit our showroom. Provide photos and any information you have about your items.",
  estimation_step2_title: "Initial Assessment",
  estimation_step2_desc: "Our experts will review your items and provide a preliminary evaluation based on photos or an in-person viewing.",
  estimation_step3_title: "Professional Appraisal",
  estimation_step3_desc: "We conduct a thorough examination, researching provenance, condition, and market value to provide an accurate appraisal.",
  estimation_step4_title: "Fair Offer",
  estimation_step4_desc: "If you choose to sell, we make a competitive offer based on current market conditions. No obligation to accept.",
  estimation_note: "Note: We are particularly interested in European furniture, fine art, silver, porcelain, and decorative objects from the 18th to early 20th centuries. However, we welcome inquiries about all types of antiques.",

  // Contact Form
  form_title: "Send Us a Message",
  form_subtitle: "Have a question or want to discuss a piece? Fill out the form below and we'll get back to you shortly.",
  form_name: "Full Name",
  form_name_placeholder: "Your full name",
  form_email: "Email Address",
  form_email_placeholder: "your@email.com",
  form_phone: "Phone Number",
  form_phone_placeholder: "+1 (000) 000-0000",
  form_subject: "Subject",
  form_subject_placeholder: "Select a subject",
  form_subject_general: "General Inquiry",
  form_subject_sell: "Sell My Items",
  form_subject_appraisal: "Appraisal Request",
  form_subject_restoration: "Restoration Services",
  form_subject_sourcing: "Sourcing Request",
  form_subject_prop: "Prop & Event Rental",
  form_subject_other: "Other",
  form_message: "Message",
  form_message_placeholder: "Tell us about your antique, your question, or how we can help you...",
  form_images: "Attach Images",
  form_images_note: "(up to 10)",
  form_add_images: "Add Images",
  form_send: "Send Message",
  form_sending: "Sending...",
  form_success: "Thank you! Your message has been sent. We'll be in touch shortly.",
  form_error: "Something went wrong. Please try again or contact us directly.",
  form_required: "*",
  form_photo_note: "To share photos of your items, please email them directly to",

  // Looking For
  looking_title: "What We're Looking For",
  looking_subtitle: "We actively seek quality antiques across various categories. Here's what interests us most",
  looking_furniture_title: "Furniture",
  looking_furniture_desc: "Period furniture including cabinets, tables, chairs, desks, and armoires from the 17th to early 20th centuries. We specialize in French, English, and Italian pieces.",
  looking_fineart_title: "Fine Art",
  looking_fineart_desc: "Original paintings, sculptures, and prints by recognized artists. We're particularly interested in European masters and Canadian historical artists.",
  looking_decorative_title: "Decorative Arts",
  looking_decorative_desc: "Fine porcelain, crystal, silver, and decorative objects. Including pieces from renowned manufacturers like Meissen, Sèvres, and Baccarat.",
  looking_timepieces_title: "Timepieces",
  looking_timepieces_desc: "Antique clocks, pocket watches, and wristwatches. We seek pieces with interesting mechanisms, fine craftsmanship, and historical significance.",
  looking_jewelry_title: "Jewelry",
  looking_jewelry_desc: "Estate jewelry, vintage pieces, and antique jewelry featuring precious stones and metals. Art Nouveau and Art Deco pieces are of particular interest.",
  looking_asian_title: "Asian Arts",
  looking_asian_desc: "Chinese, Japanese, and other Asian antiques including ceramics, bronzes, jade, and decorative objects with documented provenance.",
  looking_glass_title: "Art Glass",
  looking_glass_desc: "Pâte de verre, cameo glass, and art glass by renowned makers such as Gallé, Daum, Lalique, and Tiffany. Condition and authenticity are paramount.",
  looking_vintage_title: "Vintage Collectibles",
  looking_vintage_desc: "Mid-century modern pieces, vintage designer items, and collectibles from the 1920s-1970s. Quality and design excellence are key factors.",
  looking_architectural_title: "Architectural Elements",
  looking_architectural_desc: "Antique doors, mantels, lighting fixtures, ironwork, and other architectural salvage. We seek pieces with character and historical integrity.",
  looking_cta_text: "Don't see your item listed? We're always interested in discovering unique and exceptional pieces. Contact us to discuss what you have.",
  looking_cta_btn: "Get in Touch",

  // Footer
  footer_tagline: "Your trusted source for authentic European and North American antiques in Canada.",
  footer_quick_links: "Quick Links",
  footer_contact_info: "Contact Info",
  footer_hours: "Opening Hours",
  footer_hours_1: "Tues - Sun: 11:00 AM - 5:00 PM",
  footer_hours_2: "Monday: By Appointment Only",
  footer_copyright: "© 2024 Continental Antiques. All rights reserved.",
};

export default translation;